import { useState } from 'react';
import { Button, Layout, Row, Col, Space } from 'antd';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import CreateWorkOrderModal from '@/components/Movements/WorkOrders/Create/CreateWorkOrderModal';
import { AuthorityCodesDashboard } from '@/core/domain/enterprise/Authority/Authority.types';
import { useDashboardContext } from '@/contexts/DashboardContexProvider';
import StatisticManagerView from './StatisticManagerView';
import StatisticEstimatorView from './StatisticEstimatorView';
import StatisticFinancialView from './StatisticFinancialView';
import { useDisclosure, useWindowSize } from '@/hooks';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import SelectDashboardType from './SelectDashboardType';

import './style.less';
import ScheduleCreateModal from '@/components/Schedules/Kanban/ScheduleCreateModal';
import UserGuiding from '@/core/UserGuinding';

function AppOverview() {
  const history = useHistory();
  const { isMobile } = useWindowSize();

  const [createWorkOrderModalVisible, setCreateWorkOrderModalVisible] =
    useState(false);

  const [scheduleAddOpened, scheduleAddAction] = useDisclosure();

  const handleCreateWorkOrderModalVisible = () => {
    UserGuiding.finishPreview?.();
    setCreateWorkOrderModalVisible(!createWorkOrderModalVisible);
  };

  const handleSearchPartsClick = () => {
    history.push('/app/searchParts');
  };

  const hasWorkOrderCreatePermission = hasPermissions([
    Authorities.MOVIMENTATION_WORKORDER_ADD,
  ]);

  const { dashboardType } = useDashboardContext();

  return (
    <>
      <Layout.Header className="overview-wrapper">
        <div className="overview-wrapper-content">
          <Row gutter={[24, 24]} justify="space-between" align="middle">
            <Col flex={1}>
              <>
                {dashboardType === AuthorityCodesDashboard.managerView &&
                  hasPermissions([Authorities.DASHBOARD_VIEW_MANAGEMENT]) && (
                    <StatisticManagerView />
                  )}

                {dashboardType === AuthorityCodesDashboard.estimatorView &&
                  hasPermissions([Authorities.DASHBOARD_VIEW_BUDGET]) && (
                    <StatisticEstimatorView />
                  )}

                {dashboardType === AuthorityCodesDashboard.financialView &&
                  hasPermissions([Authorities.DASHBOARD_VIEW_FINANCEIRO]) && (
                    <StatisticFinancialView />
                  )}
              </>
            </Col>

            <Col span={24} xxl={10}>
              <Row gutter={[24, 24]} justify="end">
                <Col
                  flex={isMobile ? 1 : undefined}
                  style={{ display: 'flex', lineHeight: 0 }}
                >
                  <Space
                    style={{ width: isMobile ? '100%' : undefined }}
                    direction={isMobile ? 'vertical' : 'horizontal'}
                    size="small"
                  >
                    <SelectDashboardType />

                    {hasPermissions([Authorities.VIEW_PARTS_CONSULTATION]) && (
                      <Button
                        block={isMobile}
                        size="large"
                        type="primary"
                        onClick={handleSearchPartsClick}
                      >
                        <FormattedMessage
                          tagName="span"
                          id="layout.overview.searchParts"
                        />
                      </Button>
                    )}

                    {hasPermissions([Authorities.SHEDULE_EVERYTHING_VIEW]) && (
                      <Button
                        block={isMobile}
                        size="large"
                        type="primary"
                        className="--accent"
                        onClick={scheduleAddAction.toggle}
                      >
                        Criar agendamento
                      </Button>
                    )}

                    {hasWorkOrderCreatePermission && (
                      <Button
                        block={isMobile}
                        size="large"
                        type="primary"
                        className="--accent"
                        onClick={handleCreateWorkOrderModalVisible}
                        id="workorder-create-open"
                      >
                        <FormattedMessage
                          tagName="span"
                          id="layout.overview.newBudget"
                        />
                      </Button>
                    )}
                  </Space>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Layout.Header>

      <CreateWorkOrderModal
        visible={createWorkOrderModalVisible}
        handleVisible={handleCreateWorkOrderModalVisible}
      />

      <ScheduleCreateModal
        open={scheduleAddOpened}
        onCancel={scheduleAddAction.close}
      />
    </>
  );
}

export default AppOverview;
